import PaymentCancel from "../pages/PaymentCancel";
import PaymentSuccess from "../pages/PaymentSuccess";

const paymentRoutes = {
  path: "/payment",
  children: [
    {
      path: "success",
      element: <PaymentSuccess />,
    },
    {
      path: "cancel",
      element: <PaymentCancel />,
    },
  ],
};

export default paymentRoutes;
